const transitions = {
  fade: {
    atEnter: {
      opacity: 0
    },
    atLeave: {
      opacity: 1
    },
    atActive: {
      opacity: 1
    }
  }
}

export default transitions
